<template>
  <div class="lp">
    <header class="lp__header">
      <div class="container">
        <div class="row align-items-center">
          <div class="col-lg-7 col-xl-6">
            <router-link :to="{ name: 'home' }" class="lp__logo" @click.native="$gtm.trackEvent({ event: 'landing.click-logo-home' })">
              <LogoSVG class="lp__logo__svg" />
            </router-link>

            <h1 class="lp__header__title" title="BLACK NOVEMBER">BLACK NOVEMBER</h1>
            <h2 class="lp__header__subtitle mb-4"><strong>CyberClass</strong> com <strong>R$50,00</strong> de desconto! </h2>

            <p class="lp__header__caption">
              Invista em sua carreira nesta Black November e saia à frente da concorrência!
            </p>

            <LandingButton @click="goToPlans(); $gtm.trackEvent({ event: 'landing.click-cta-plans', value: 'top' })">Investir na minha carreira</LandingButton>

            <span class="lp__header__disclaimer">Promoção válida até 30/11/2022</span>
          </div>

          <div class="col-lg-5 col-xl-6 d-none d-lg-block">
            <img class="lp__header__preview" src="@/assets/img/landing/mobile-desktop-preview.png" alt="">
          </div>
        </div>
      </div>

      <img class="lp__header__bg" src="@/assets/img/landing/orange-gradient-bg.svg" alt="">
    </header>

    <section class="lp__section mb-0 pb-0">
      <img class="lp__section__bg" src="@/assets/img/landing/logo-bg.svg" />

      <div class="container">
        <div class="lp__wrap text-center">
          <h2 class="lp__heading__title">O INVESTIMENTO QUE GERA MAIS RETORNO É O INVESTIMENTO EM VOCÊ MESMO!</h2>
          <p class="lp__paragraph">Desenvolver uma habilidade lucrativa para trabalhar com Marketing Digital na internet é o melhor investimento que você pode fazer pela sua carreira, e a CyberClass é o melhor lugar para se fazer isso.</p>
  
          <img class="lp__img img-fluid" src="https://i.imgur.com/wLylNGO.png" alt="Mercado de Marketing Digital está aquecido" />
        </div>
      </div>
    </section>

    <section class="lp__section">
      <div class="container">
        <div class="lp__wrap text-center">
          <p class="lp__paragraph mb-3">Na plataforma você terá acesso à diversos cursos, treinamentos e workshops com as habilidades mais procuradas do Marketing Digital, tais como:</p>

          <div class="row normal-gutters mb-4">
            <div
              v-for="title in ['Social Media', 'Gestor de Tráfego', 'Copywriting', 'Programação', 'Design', 'Edição de vídeo', 'E muito mais!']"
              :key="title"
              class="col-6 col-xl-3 mb-4 d-flex"
            >
              <FeatureBox class="theme-black d-flex align-items-center justify-content-center w-100">
                <span slot="title" v-html="title"></span>
              </FeatureBox>
            </div>
          </div>

          <p class="lp__paragraph mb-3">E, aprendendo uma (ou mais) delas, pode se candidatar a vagas em diversas empresas e/ou atender diversos clientes simultaneamente.</p>

          <img class="lp__img" src="https://i.imgur.com/yFhBoRz.png" alt="Muitas vagas para Copywriting" />

          <img class="lp__img" src="https://i.imgur.com/EKgcLin.png" alt="Oportunidades de Desenvolvedor no Brasil" />

          <h2 class="lp__heading__title">Enquanto investimentos tradicionais retornam algo entre 6% a 15% ao ano, investir em apenas uma dessas habilidades pode te gerar 97% de retorno já no primeiro mês.</h2>


          <div class="row normal-gutters mb-4 text-left">
            <div class="col-12 col-xl-4 mb-4 d-flex w-100">
              <FeatureBox class="theme-black w-100">
                <span slot="title" v-html="'R$29/mês*'"></span>
                <span slot="description" v-html="'Investimento na CyberClass'"></span>
              </FeatureBox>
            </div>
            <div class="col-12 col-xl-4 mb-4 d-flex w-100">
              <FeatureBox class="theme-black w-100">
                <span slot="title" v-html="'R$1.000,00/mês'"></span>
                <span slot="description" v-html="'Pagamento médio para um Copywriter iniciante'"></span>
              </FeatureBox>
            </div>
            <div class="col-12 col-xl-4 mb-4 d-flex w-100">
              <FeatureBox class="theme-black w-100">
                <span slot="title" v-html="'97% em apenas um mês'" style="color: #00FF00"></span>
                <span slot="description" v-html="'O seu retorno'"></span>
              </FeatureBox>
            </div>
          </div>

          <p class="lp__paragraph">* Valor sem considerar o desconto da Black November.</p>
        </div>
      </div>
    </section>

    <section class="lp__section">
      <div class="container">
        <div class="lp__wrap">
          <h2 class="lp__heading__title">E não é só isso… Além de te dar as habilidades mais lucrativas da internet, com a CyberClass você também vai aprender a controlar suas finanças:</h2>

          <div class="row normal-gutters">
            <div class="col-md-3 mb-2 mb-md-0">
              <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/4qru/FVpfaKayhWIvpAc0WOHftzVyQcThL5XeEvhmC1Uj.webp" />
            </div>
            <div class="col-md-3 mb-2 mb-md-0">
              <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/vl/NtSOxmux5DRuflEv0LJNnfIjoGY6bhb57MvTyeFp.webp" />
            </div>
            <div class="col-md-3 mb-2 mb-md-0">
              <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/qvceaooqtj/MMF4nu5HKwRFDQ8nEIJ7ZGVOb2IcS0NKEy9gVTo6.webp" />
            </div>
            <div class="col-md-3 mb-2 mb-md-0">
              <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/dtw/v2digAy8T6Iiq2ppzob8wIuIDledMPGpBfX8dYNg.webp" />
            </div>
          </div>
        </div>

        <div class="text-center mt-5">
          <LandingButton @click="goToPlans(); $gtm.trackEvent({ event: 'landing.click-cta-plans', value: 'top' })">Quero investir na minha carreira</LandingButton>
        </div>
      </div>
    </section>

    <section class="lp__section">
      <div class="container">
        <div class="lp__wrap text-center">
          <h2 class="lp__heading__title">Essas são apenas algumas das vantagens de trabalhar no mercado digital:</h2>

          <div class="row">
            <div class="col-12 mb-4">
              <FeatureBox class="theme-black w-100">
                <span slot="title" style="color: #fff">Você não precisa ficar 4 ou 5 anos em uma Faculdade para começar a trabalhar.</span>
                <span slot="description">
                  Você não precisa ter nenhum diploma para ser Copywriter, Social Media, Gestor de Tráfego, Coprodutor…<br><br>
                  Você pode começar hoje mesmo a desenvolver uma habilidade digital e já começar a ganhar salários muito maiores do que os trabalhos comuns. 
                </span>
              </FeatureBox>
            </div>

            <div class="col-12 mb-4">
              <FeatureBox class="theme-black w-100">
                <span slot="title" style="color: #fff">Você não precisa acordar cedo para pegar transporte público.</span>
                <span slot="description">A maioria das carreiras digitais não exigem trabalho presencial e tem muita flexibilidade de horários. Você nunca mais vai precisar acordar cedo em dias frios, correr para pegar ônibus ou metrô lotado e ainda ficar aguentando chefe chato…</span>
              </FeatureBox>
            </div>

            <div class="col-12 mb-4">
              <FeatureBox class="theme-black w-100">
                <span slot="title" style="color: #fff">Você não precisa bater na porta das empresas procurando trabalho.</span>
                <span slot="description">Existem alguns sites que você pode se cadastrar e automaticamente os potenciais clientes vão vir até você. E o melhor é que esse cadastro é de graça. Você só precisa saber escolher os sites certos e ter uma noção da área que quer atuar.</span>
              </FeatureBox>
            </div>

            <div class="col-12 mb-4">
              <FeatureBox class="theme-black w-100">
                <span slot="title" style="color: #fff">Você não precisa se tornar um “blogueirinho”.</span>
                <span slot="description">
                  Muita gente mal intencionada diz que para ter sucesso no Marketing Digital você precisa aparecer, gravar stories, postar vídeo todo dia…<br><br>
                  <u><strong>Isso é completamente falso.</strong></u><br><br>
                  Você pode desenvolver diversas habilidades, trabalhar 100% atrás das câmeras e ainda ganhar salários altíssimos…
                </span>
              </FeatureBox>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="lp__section">
      <div class="container">
        <div class="lp__wrap">
          <header class="lp__heading">
            <h2 class="lp__heading__title">Confira um pouco do que você vai encontrar na CyberClass</h2>
            <h3 class="lp__heading__subtitle">Receba acesso exclusivo a mais de 40 cursos e workshops e todas as atualizações durante seu período de acesso:</h3>
          </header>


          <div class="mb-5">
            <p class="lp__paragraph mb-3">Domine as habilidades que estão em alta no Marketing Digital.</p>

            <div class="row normal-gutters">
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/jrj/HN55EUEB9NMB83SGCqYu3yWfdMelwfuFTUitshIB.webp" />
              </div>
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/pufq/qKZGlfpqdMlmNMYhQBI1nzfRu2aDVLiQsV25sY0P.webp" />
              </div>
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/yoi/tWTvj8fWgKDLRX0iuoJ99ZI7V0mOURiA7zuuycZe.webp" />
              </div>
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/ou5a/yruMYjpYu6iJAhrIUcabA00yoWJ1vRfwuaeFcEyS.webp" />
              </div>
            </div>
          </div>

          <div class="mb-5">
            <p class="lp__paragraph mb-3">Aprenda a construir o seu próprio negócio.</p>

            <div class="row normal-gutters">
              <div class="col-md-4 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/5/n0X4sDz5HPYNFLJTFObR23SDVoAEVMMK7mtheVJO.webp" />
              </div>
              <div class="col-md-4 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/f/GWKUH2BYqoCSZ3JWOOaYHM4drrI3PjkvrQTTJBb4.webp" />
              </div>
              <div class="col-md-4 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/wg/CPPoqYe3h8yrqNHqJBKA8WIaQPJQTHJmkMo4EoSc.webp" />
              </div>
            </div>
          </div>

          <div class="mb-5">
            <p class="lp__paragraph mb-3">Seja um especialista em Design e Edição de Vídeos.</p>

            <div class="row normal-gutters">
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/xxe/o6aF2Z9btYeTS95vYLFkyAiIpAuk50Ms0LxIl0Ln.webp" />
              </div>
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/rmkb/fyGrWfqpWxPcfoMVDyFJhXolxVONAzL8NIOVCMJl.webp" />
              </div>
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/ubr/AJlI9e83MSx6R073eyyVCki81nWQVxYSTzCUICVh.webp" />
              </div>
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/axpfwht/VZZ1MQIyf2KT5pouKuFR2LCpg8Fn1UI6IASUUaZy.webp" />
              </div>
            </div>
          </div>

          <div class="mb-5">
            <p class="lp__paragraph mb-3">Crie o seu canal de sucesso no YouTube.</p>

            <div class="row normal-gutters">
              <div class="col-md-4 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/luo/3ASZDUppoOlPTRoDyrvbytBpYdLOvIYzae4tuggF.webp" />
              </div>
              <div class="col-md-4 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/hkhk/SlMYT8xGQRDiV9tXrkozhHc93ocS0VwgZtLVKVri.webp" />
              </div>
              <div class="col-md-4 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/0aa/qRmdOrDkuk7WKnt1M2dgSy0WbDyJVElgLSGJBjGK.webp" />
              </div>
            </div>
          </div>

          <div class="mb-5">
            <p class="lp__paragraph mb-3">Faça dinheiro com as habilidades que o mercado procura (sem aparecer).</p>

            <div class="row normal-gutters">
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/ioo/46qAgFB230DIvft74HwBnp9kyfXseqrUEDDnwU4H.webp" />
              </div>
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/sno/8OtvWaV5XO0ZWZ8Wkx2ZKjHDiK7f12ZQLAxEQNUn.webp" />
              </div>
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/zw7/0fSTWRr2DT8jFT6AFACnfxwGRLqMm9pwiMg1qbWC.webp" />
              </div>
              <div class="col-md-3 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/rll/O77mFuyLe9FtGHNiaEJMUJzQcI5rjcnLybn5VtUW.webp" />
              </div>
            </div>
          </div>

          <div class="mb-5 text-center">
            <p class="lp__paragraph mb-3">Aprenda a língua mais utilizada mundialmente e tenha vantagens.</p>

            <div class="row justify-content-center normal-gutters">
              <div class="col-5 mb-2 mb-md-0">
                <img class="img-fluid" src="https://api.cyberclass.com.br/storage/thumb/l/iJQ6QheAEHrTDf91EnWDdhxuD1IPiP6dGEEPvUci.webp" />
              </div>
            </div>
          </div>
        
          <div class="text-center mt-5">
            <LandingButton @click="goToPlans(); $gtm.trackEvent({ event: 'landing.click-cta-plans', value: 'top' })">Quero investir na minha carreira</LandingButton>
          </div>
        </div>
      </div>
    </section>

    <section class="lp__section">
      <div class="container">
        <div class="lp__wrap">
          <h2 class="lp__heading__title">CONFIRA ALGUNS RESULTADOS DOS NOSSOS ALUNOS…</h2>

          <div class="row justify-content-center normal-gutters">
            <div class="col-md-6">
              <img class="lp__img" src="https://i.imgur.com/8aVpXzJ.png" />
            </div>

            <div class="col-md-6">
              <img class="lp__img" src="https://i.imgur.com/mBbes1s.png" />
            </div>

            <div class="col">
              <img class="lp__img" src="https://i.imgur.com/V911n8S.png" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="lp__section">
      <div class="container">
        <div class="lp__wrap text-center">
          <h2 class="lp__heading__title">A CyberClass é diferente de tudo que você já viu!</h2>

          <p class="lp__paragraph mb-4">
            Na internet existem muitos cursos que ensinam Marketing Digital, mas nenhum deles se compara a CyberClass, sabe por quê?
          </p>

          <p class="lp__paragraph mb-4">
            Porque aqui você terá aulas apenas com quem <strong>já tem grandes resultados.</strong>
          </p>

          
          <p class="lp__paragraph mb-4">
            Todos os nossos professores passam por um rígido processo seletivo e precisam provar que obtiveram grandes resultados antes de dar aula. Eu mesmo, inclusive, trabalho com a internet desde 1999 e lancei a plataforma em 2021, somente após já ter faturado milhões de reais…
          </p>

          <p class="lp__paragraph mb-5">
            <strong>Você não precisa de mais um curso, você precisa de resultados. <u>E é isso que a CyberClass vai entregar a você!</u></strong>
          </p>

          <h2 class="lp__heading__title">A HORA É AGORA! Tenha acesso a CyberClass por apenas R$24/mês na Black November e comece a investir em sua carreira!</h2>

          <div class="text-center mt-5">
            <LandingButton @click="goToPlans(); $gtm.trackEvent({ event: 'landing.click-cta-plans', value: 'top' })">Quero investir na minha carreira</LandingButton>
          </div>
        </div>
      </div>
    </section>

    <section class="lp__section">
      <div class="container">
        <div class="lp__wrap text-center">
          <h2 class="lp__heading__title mb-4">Seu investimento está protegido</h2>
          
          <div class="lp__figure-box">
            <span>Você pode experimentar a CyberClass pelo período de 7 dias. Ou você fica feliz com o maior portal de treinamentos para quem quer ganhar dinheiro na internet e começa a sua jornada rumo a resultados incríveis recorrentes, ou, você fica feliz com todo o seu dinheiro de volta. <span class="hl">È ganhar ou ganhar!</span></span>
            <br><br>
            <span><strong>#NÂOVOUPARAR</strong> - <span class="hl">Peter Jordan</span></span>
          </div>

          <div class="text-center mt-5">
            <LandingButton @click="goToPlans(); $gtm.trackEvent({ event: 'landing.click-cta-plans', value: 'top' })">Aperte aqui para se inscrever</LandingButton>
          </div>
        </div>
      </div>
    </section>

    <section class="lp__section">
      <div class="container">
        <div class="lp__wrap">
          <h2 class="lp__heading__title text-center mb-4">Perguntas Frequentes</h2>

          <SupportFAQItem
            class="lp__faq"
            v-for="faq in faqs"
            :key="faq.name"
            :faq="faq"
          />
        </div>
      </div>
    </section>

    <footer class="lp__footer">
      <div class="container">
        <ul
          v-for="(footerMenu, index) in footerMenuSet"
          :key="`footer-${index}`"
        >
          <li v-for="link in footerMenu" :key="link.text" >
            <router-link :to="link.to">{{ link.text }}</router-link>
          </li>
        </ul>
        <ul>
          <li>
            <a href="mailto:cursos@cyberclass.com.br" target="_blank">cursos@cyberclass.com.br</a>
          </li>
        </ul>
      </div>
    </footer>
  </div>
</template>

<script>
  import { getIndex } from '@/api/course.api'
  import { getAllPlans } from '@/api/plan.api'
  import LogoSVG from '@/components/svg/LogoSVG'
  import TextCarousel from '@/components/text/TextCarousel'
  import LandingButton from '@/components/buttons/LandingButton'
  import MosaicCarousel from '@/components/carousel/MosaicCarousel'
  import SubscriptionPricingTable from '@/components/landing/SubscriptionPricingTable'
  import FeatureBox from '@/components/landing/FeatureBox'
  import CourseFloatThumb from '@/components/course/CourseFloatThumb'
  import SupportFAQItem from '@/components/support/SupportFAQItem'


  export default {
    components: {
      LogoSVG,
      FeatureBox,
      SupportFAQItem,
      TextCarousel,
      LandingButton,
      MosaicCarousel,
      SubscriptionPricingTable,
      CourseFloatThumb
    },

    metaInfo: {
      title: 'CyberClass - O momento de alcançar seus objetivos é AGORA!',
    },

    data: () => ({
      faqs: [
        {
          name: 'E se eu não conseguir acompanhar as aulas?',
          body: 'Se você estiver tendo dificuldades em alguma aula ou módulo, você poderá refazer as aulas ou módulos inteiros quantas vezes quiser e sem pagar adicionais. Você decide se está preparado ou não para passar para o próximo módulo.'
        }, {
          name: 'E se eu não gostar? Como funciona a garantia?',
          body: `Entre primeiro, assista às aulas e preocupe-se depois. Você tem 7 dias para testar a plataforma e assistir todas as aulas sem compromisso. Se dentro desse período você achar que não aprendeu nada, nós devolvemos todo o seu dinheiro de volta.
          <br><br>
          Não tem como você perder! Entre e aproveite ou tenha seu dinheiro de volta dentro desse período.`
        }, {
          name: 'Por onde será o acesso das aulas?',
          body: `Não se preocupe, a plataforma do curso é totalmente segura e você receberá todas as informações de acesso pelo e-mail que você cadastrou assim que o pagamento for registrado.`
        }, {
          name: 'Quando as aulas estarão disponíveis?',
          body: `Assim que você entrar na plataforma as aulas já estarão disponíveis lá, para que você possa assistir e estudar no seu ritmo.`
        }, {
          name: 'E se eu tiver algum problema ao longo do curso?',
          body: `O nosso suporte vai estar à sua disposição, é só chamar que te ajudaremos com qualquer problema ou dúvida.`
        }, {
          name: 'Quais são as formas de pagamento?',
          body: `Nós trabalhamos com as seguintes formas de pagamento:
            <br>
            <ul>
              <li>- Cartão de crédito, em até 12x sem juros</li>
              <li>- Boleto à vista</li>
              <li>- PayPal</li>
            </ul>
          `
        }, {
          name: 'Eu posso aprender sozinho na internet e de graça, por que comprar esse curso?',
          body: `
          Você pode tentar aprender algo no meio da bagunça que são os vários vídeos e textos soltos disponíveis na internet e sofrer com isso. Ou você pode adquirir um passo a passo testado e aprovado, com uma trilha segura e de aprendizado fácil, pensado por professores epecialistas no assunto com anos de prática e que já trabalharam muito para aprender a chegar aonde estão. 
          <br><br>
          Todas as estratégias ensinadas são resultados de anos de prática, e você pode economizar o seu tempo por apenas esse preço.`
        }, {
          name: 'Tem algum módulo presencial?',
          body: `Não, o curso é totalmente on-line. Ao invés de ter um horário rígido e ter que perder tempo no trânsito, você poderá assistir quando quiser, onde quiser, e quantas vezes quiser.`
        }, {
          name: 'O que eu preciso para estudar e aprender?',
          body: `Apenas de um computador com conexão com a internet e a disposição necessária para aplicar tudo o que for ensinado.`
        }, {
          name: 'Tenho outras dúvidas, o que faço?',
          body: `Bora bater um papo 😉 Qualquer dúvida ou problema entre em contato com o nosso e-mail de suporte <a href="mailto:cursos@cyberclass.com.br">cursos@cyberclass.com.br</a>.
          <br><br>
          Também temos atendimento via chat de 8 às 19h de segunda a sexta-feira.`
        }
      ],

      courses: [],

      plans: [],
      
      titles: [
        'objetivos',
        'sonhos',
        'metas',
        'inspiração',
        'vontade'
      ],

      features: [
        {
          title: 'Material<br>complementar',
          description: 'Conteúdo adicional as aulas como exercícios, planilhas e fontes de informaçoes extras.'
        }, {
          title: 'Grupos<br>de discussão',
          description: 'Troque experiências com outros alunos com mesmos interesses e objetivos.'
        }, {
          title: 'Acompanhamento<br>de progresso',
          description: 'Acompanhe seu progresso de forma interativa e contínua em seus cursos.'
        }, {
          title: 'Certificado<br>de conclusão',
          description: 'Obtenha um Certificado de Conclusão oficial CyberClass para turbinar seu currículo.'
        }, {
          title: 'Acessos<br>aos Workshops',
          description: 'Tenha acesso a Workshops de assuntos variados ministrados por experts em suas áreas.'
        }, {
          title: 'Acessos<br>aos e-books',
          description: 'Tenha acesso aos e-books exclusivos com diversos métodos aplicáveis.'
        }, {
          title: 'Acesso aos<br>cursos futuros',
          description: 'Total acesso aos cursos e materiais futuros que são criados constantemente.'
        }, {
          title: 'Lives<br>com experts',
          description: 'Acesso à lives de conversas, dicas e dúvidas com diversos experts.'
        }
      ]
    }),

    mounted () {
      this.fetchCourses()
      this.fetchPlans()
    },

    computed: {
      footerMenuSet () {
        return [
          [
            { text: 'Termos de Uso', to: {name: 'legal.terms'} },
          ], [
            { text: 'Política de Privicidade', to: {name: 'legal.privacy'} }
          ]
        ]
      },

      coursePrimaryKey () {
        return (index) => (index - 1) * 2
      },

      courseSecondaryKey () {
        return (index) => this.coursePrimaryKey(index) + 1
      }
    },

    methods: {
      goToPlans () {
        window.location.href = 'https://pay.hotmart.com/E53317988Y?off=agmu2ypb&sck=cyc_blackfriday_pv_principal&split=12'
      },

      async fetchCourses () {
        let courses = await getIndex({ perpage: 100 })

        if (courses.length % 2 == 1) {
          courses.splice(Math.round(courses.length / 2), 1)
        }

        this.courses = courses
      },

      async fetchPlans() {
        this.plans = await getAllPlans()
      }
    }
  }
</script>


<style scoped lang="scss">
  @import "~animate.css/animate.min.css";

  $gutter: 40px;

  img {
    border-radius: 8px;
  }

  .lp {
    background: #161616;
    position: relative;
  }

  .container {
    position: relative;
    z-index: 2;

    @media (min-width: 1600px) {
      max-width: 1600px;
    }
  }

  .row:not(.no-gutters):not(.normal-gutters) {
    margin-left: -$gutter;
    margin-right: -$gutter;
  }
  
  .row:not(.no-gutters):not(.normal-gutters) > .col,
  .row:not(.no-gutters):not(.normal-gutters) > [class*="col-"] {
    padding-right: $gutter;
    padding-left: $gutter;
  }

  .lp {
    position: relative;
    overflow: hidden;
    font-family: 'Inter';
    color: #fff;

    &__faq {
      margin-bottom: 10px;
      background: rgba(#fff, .05);

      ::v-deep &.faq-item--collapsed .faq-item__body {
        border-top: 1px solid rgba(#fff, .05);
      }
    }

    .section-spacing { padding: 4.375rem 0 }

    &__footer {
      text-align: center;

      ul {
        margin-bottom: 30px;
        display: inline-flex;

        a {
          display: block;
          padding: 0 10px;
          color: #ff8000;
          font-size: 15px;
        }
      }
    }

    &__section {
      @extend .section-spacing;

      position: relative;

      &--pricing { margin-top: -2rem }

      &--negative-spacing { margin-top: -5rem }

      &__bg {
        z-index: 0;
        position: absolute;
        opacity: 0.5;
        top: 50%;
        left: 0;
        transform: translateY(-50%);

        @media (max-width: 992px) {
          top: 0;
          transform: translateY(0);
        }
      }
    }

    &__header {
      position: relative;

      &__bg {
        z-index: 1;
        position: absolute;
        top: 0;
        left: 0;
        min-width: 100vw;
        height: 100%;
      }

      &__preview {
        margin-top: 80px;
      }

      &__title {
        font-size: 4rem;
        margin-bottom: 1.875rem;
        position: relative;
        font-weight: 900;
        color: lighten(#000, 10);
        text-shadow: 0 0 5px rgba(#000, .2);
        letter-spacing: -0.25px;

        &:before, &:after {
            content: attr(title);
            color: rgba(#fff, .03);
            position: absolute;
        }

        &:before { top: 1px; left: 1px }
        &:after  { top: 2px; left: 2px }

        .hl {
          font-weight: 700;
        }
      }

      &__subtitle {
        display: inline-block;
        background-color: rgba(#000, .9);
        color: #fff;
        padding: 16px 24px;
        font-size: 22px;
        border-radius: 32px;
        font-weight: 400;
      }

      &__disclaimer {
        display: block;
        margin-top: 32px;
        font-size: 14px;
      }
      
      &__caption {
        font-size: 1.25rem;
        line-height: 1.875rem;
        font-weight: 600;
        max-width: 29.0625rem;
        margin-bottom: 2.5rem;
      }
    }

    &__logo {
      display: block;
      margin-bottom: 3.125rem;

      &__svg {
        width: 18.75rem;

        & ::v-deep path { fill: #fff !important }
      }
    }

    &__intro-video {
      border: 8px solid #fff;
      box-shadow: 0px 0px 50px 12px rgba(0, 0, 0, .1);

      &, iframe { border-radius: 10px }
    }

    &__img {
      width: auto;
      max-width: 100%;
      margin: 2.5rem 0;
      border-radius: 16px;
      box-shadow: 10px 10px 16px rgba(#fff, .025);
    }

    &__wrap {
      margin: 0 auto;
      max-width: 992px;;
    }

    &__heading {
      margin: 0 auto;
      margin-bottom: 50px;
      text-align: center;
      max-width: 680px;

      &__title {
        color: #fff;
        color: #ff8000;
        text-shadow: 0 0 5px rgba(#ff8000, .8);
        font-weight: 600;
        font-size: 2rem;
        margin-bottom: 1.25rem;
      }

      & > &__title { margin-bottom: 0.625rem }

      &__subtitle {
        color: #737373;
        font-weight: 600;
        font-size: 1.25rem;

        .hl { color: #ff8000 }
      }
    }

    &__paragraph {
      color: lighten(#000, 90);
      font-size: 1.25rem;
      line-height: 2rem;
      font-weight: 600;
      letter-spacing: -0.1px;

      .hl {
        color: #ff8000;
      }
    }

    &__figure-box {
      position: relative;
      max-width: 1120px;
      margin: 0 auto;
      font-family: 'Inter';
      font-size: 1.375rem;
      line-height: 2.1875rem;
      padding: 3.125rem;
      color: #737373;
      box-shadow: 9px 9px 20px -5px rgba(0, 0, 0, 0.25);
      border-radius: 15px;
      backface-visibility: hidden;
      transform-style: preserve-3d;
      transition: .5s all;
      background: lighten(#000, 5);

      &:hover {
        transform: scale(1.1);
      }

      .hl { color: #ff8000 }

      @media (max-width: 1366px) {
        padding-left: 22%;
      }

      @media (max-width: 992px) {
        padding-left: 3.125rem;
        padding-right: 3.125rem;

        &:before {
          opacity: .06;
        }
      }
    }

    @media (max-width: 992px) {
      &__logo {
          text-align: center;
        }

      &__header {
        padding: 2.5rem 0 5.625rem;
        
        &__preview {
          width: auto;
          max-width: 100%;
        }

        &__title {
          font-size: 2.8125rem;
          margin-bottom: 30px;
          position: relative;

          .hl { display: block }
        }
      }
    } 
  }
</style>